
import { Component, OnInit } from '@angular/core';
import { Constants } from '../../constants';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HomeService } from 'src/app/service/home.service';
import { ThemePalette } from '@angular/material/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MsalService } from 'src/app/msal';
import { FormControl } from '@angular/forms';
import { catchError, EMPTY } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  navlinks: any;
  userName: string = '';
  site: any = '';
  site1: any
  userDetails: any = {};
  siteConfigRules: any = {};
  enableHomeGrey = false;
  enableHomeRed = true;
  activeBoard: boolean = true;
  highlightHome: boolean = true;
  highlightMenuItem: any = [];
  highlightInvestigation = false;
  highlightPlanVersusActual = true;
  highlightMasterSettings = false;
  highlightHistory = false;
  role: any = [];
  siteType: any = '';
  selected = new FormControl();
  arrowHidden: boolean = true;
  currentIndex: any = 0;
  links: any = [];
  count: any = 1;
  validationComplete: boolean = false;
  validatedMenuItem: any = [];

  constructor(private router: Router, private constants: Constants, private homeService: HomeService, private ngxUiLoaderService: NgxUiLoaderService, private activatedRoute: ActivatedRoute, public authService: MsalService) {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent);
    this.highlightMenuItem.push([{ link: 'home', url: '/home', visibility: true, roles: 'ALL', mainMenuItem: true }]);
    this.highlightMenuItem.push([{ link: 'documentControl', url: '/document-control', visibility: true, roles: 'Document Control', mainMenuItem: true }]);
    this.highlightMenuItem.push([{ link: 'unload', url: '/unload', visibility: true, roles: 'ALL', mainMenuItem: true }]);
    this.highlightMenuItem.push([{ link: 'reload', url: '/reload', visibility: true, roles: 'ALL', mainMenuItem: true }]);
    this.highlightMenuItem.push(
      [{ link: 'boxLevel', url: '/box-level', visibility: true, roles: 'Box Member', mainMenuItem: true },
      { link: 'boxLevelSub/documentControl', visibility: true, roles: 'Box Document Control' }
      ]);
    this.highlightMenuItem.push([{ link: 'returnables', url: '/returnables', visibility: true, roles: 'ALL', mainMenuItem: true },
    ]);
    //this.highlightMenuItem.push([{ link: 'reports', url: '/reports', visibility: true, roles: 'ALL', mainMenuItem: true }]);
    this.highlightMenuItem.push(
      [{ link: 'reports', url: '/reports', visibility: true, roles: 'ALL', mainMenuItem: true },
      { link: 'reportsSub/laneSummary', visibility: true, roles: 'Lane Summary' },
      { link: 'reportsSub/laneDataDownload', visibility: true, roles: 'Lane Data Download' }
      ]);
    this.highlightMenuItem.push(
      [{ link: 'administration', url: '/administration', visibility: true, roles: 'User Admin, Connection Admin, Compliance Admin, Compliance Admin, Compliance Viewer, Dock Door Admin', mainMenuItem: true },
      { link: 'administrationSub/siteConfiguration', visibility: true, roles: 'Site Admin, Compliance Admin' },
      { link: 'administrationSub/userManagement', visibility: true, roles: 'User Admin' },
      { link: 'administrationSub/cLoadManagement', visibility: true, roles: 'C-Load Admin' },
      { link: 'administrationSub/connectionManagement', visibility: true, roles: 'Connection Admin' },
      { link: 'administrationSub/workDayManagement', visibility: true, roles: 'Connection Admin' },
      { link: 'administrationSub/dockManagement', visibility: true, roles: 'Connection Admin' },
      { link: 'administrationSub/shopManagement', visibility: true, roles: 'Connection Admin' },
      { link: 'administrationSub/complianceManagement', visibility: true, roles: 'Compliance Admin' },
      { link: 'administrationSub/complianceReview', visibility: true, roles: 'Compliance Admin, Compliance Viewer' },
      { link: 'administrationSub/dockDoorManagement', visibility: true, roles: 'Dock Door Admin' },
      { link: 'administrationSub/systemManagement', visibility: true, roles: 'IS Admin' },
      { link: 'administrationSub/pcbConfig', visibility: true, roles: 'PCB Admin' },
      ]);
    this.highlightMenuItem.push([{ link: 'exportParts', url: '/export-parts', visibility: true, roles: 'Exports Scan Member', mainMenuItem: true },
    ]);
    this.highlightMenuItem.push([{ link: 'history', url: '/history', visibility: true, roles: 'ALL', mainMenuItem: true }]);
  }

  ngOnInit(): void {
    console.log('header')
    this.ngxUiLoaderService.start(this.constants.LoaderComponent);
    this.homeService.userDetails.subscribe((data: any) => {
      this.getUserDetails();    
    })
    let userDetailsLocal = sessionStorage.getItem("userDetails");
    let loggedInStatus = sessionStorage.getItem("LoggedIn");
    if (loggedInStatus == 'true') {
      console.log('loggedInStatus-------->HEADER')
      if (userDetailsLocal != null) {
        this.getUserDetails();
      }
      else {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
        localStorage.clear();
        sessionStorage.clear();
        this.router.navigate(['/'])
        this.logout();
      }
    }

    this.navlinks = this.constants.navLinkItems;
    this.homeService.primarySite.subscribe((data: any) => {
      this.site = data;
    })
    this.homeService.updateUserRole.subscribe((data: any) => {
      this.getUserDetails();
    });
    this.homeService.updateMenuHighlight.subscribe((data: any) => {
      this.togglerBreadcrumbz(data);
    }); 
    this.homeService.updateSiteValue.subscribe((data: any) => {
      this.toggler('home');
    });

    window.addEventListener('popstate', () => {
      this.ngxUiLoaderService.start(this.constants.LoaderComponent);
      let activeMenuLinks: any = localStorage.getItem('activeMenuLinks');
      if (activeMenuLinks != null)
        activeMenuLinks = activeMenuLinks.split(',');
      let url = window.location.href.split('/')
      this.selected.setValue(null);
      setTimeout(() => {
        this.currentIndex = activeMenuLinks?.findIndex((x: any) => x == ("/" + url[3].trim()));
        this.selected.setValue(this.currentIndex);
        this.toggler(url[3]);
        if (url[3] !== 'home' && url[3] !== '' && url[3] !== '#') {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
        }
      }, 1500);
    });
    window.addEventListener('load', () => {
      this.ngxUiLoaderService.start(this.constants.LoaderComponent);
      // this.selected.setValue(null);
      this.callGetUserDetails();
      setTimeout(() => {
        this.currentIndex = Number(localStorage.getItem('currentIndex'));
        this.selected.setValue(this.currentIndex);
        let url = window.location.href.split('/')
        this.toggler(url[3]);
        if (url[3] !== 'home' && url[3] !== '' && url[3] !== '#') {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
        }
      }, 1500);
    });
  }

  onTabClick(index: number) {
    localStorage.setItem('currentIndex', index.toString());
  }

  togglerBreadcrumbz(pageHeader: string): void {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent);
    this.selected.setValue(null);
    this.currentIndex = Number(localStorage.getItem('currentIndex'));
    console.log(this.currentIndex);
    this.selected.setValue(this.currentIndex);
    this.toggler(pageHeader);
  }

  toggler(pageHeader: string): void {
    if (pageHeader.includes('home') || pageHeader == '' || pageHeader == '#') {
      this.highlightHome = true;
    } else {
      this.highlightHome = false;
    }
    let userDetailsLocal: any;
    let siteConfigRulesLocal: any;
    if (localStorage.getItem("userDetails") !== null) {
      userDetailsLocal = localStorage.getItem("userDetails");
      siteConfigRulesLocal = sessionStorage.getItem("siteConfigRules");      
      sessionStorage.setItem("userDetails", userDetailsLocal);
    } else {
      userDetailsLocal = sessionStorage.getItem("userDetails");
      siteConfigRulesLocal = sessionStorage.getItem("siteConfigRules");
    }
    if (userDetailsLocal !== null) {
      this.userDetails = JSON.parse(userDetailsLocal);
      this.siteConfigRules = JSON.parse(siteConfigRulesLocal);
      this.userName = this.userDetails?.firstName + " " + this.userDetails?.lastName;
      this.role = this.userDetails?.role;
      this.role = this.userDetails?.role;
      this.site = this.userDetails?.primarySiteName;
      this.siteType = this.siteConfigRules?.siteType;
    }
  }

  getUserDetails() {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent);
    let userDetailsLocal = sessionStorage.getItem("userDetails");
    let siteConfigRulesLocal = sessionStorage.getItem("siteConfigRules");     
    if (userDetailsLocal != null) {
      this.userDetails = JSON.parse(userDetailsLocal);
      if (siteConfigRulesLocal != null) {
        this.siteConfigRules = JSON.parse(siteConfigRulesLocal);      
        this.siteType = this.siteConfigRules?.siteType;
      }
      this.userName = this.userDetails?.firstName + " " + this.userDetails?.lastName;
      this.role = this.userDetails?.role;
      this.site = this.userDetails?.primarySiteName;
      this.getInitials();
      this.verifyMenuByRole();
    }
    else {
      this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['/'])
      this.logout();
    }
  }

  verifyMenuByRole() {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent);
    this.highlightMenuItem.forEach((element: any) => {
      element.forEach((element2: any) => {
        if (element2.mainMenuItem) {
          element2.visibility = this.verifyByRole(element2.roles, element2.link, element2.url, true);
          this.count++;
          if (this.count == 9) {
            this.validationComplete = true;
            setTimeout(() => {
              // this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
            }, 2000);
          }
        }
        else {
          element2.visibility = this.verifyByRole(element2.roles, element2.link, element2.url);
        }
        let links = element2.link.split('/');
        if (links.length > 1) {
          this.validatedMenuItem[links[0] + "" + [links[1]]] = element2.visibility;
        } else {
          this.validatedMenuItem[links[0]] = element2.visibility;
        }
      });
    });
    console.log(this.validatedMenuItem)
  }

  verifyByRole(module: any, pageLink: any, url: any, mainMenuItem: boolean = false): boolean {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent);
    let moduleArr = module.split(',');
    let returnValue = false;
    if (this.role.length > 0) {
      moduleArr.forEach((element: any) => {
        if(moduleArr == "Lane Summary" || moduleArr == "Lane Data Download")
        {
          if(this.siteType == 'LaneControl' || this.siteType == "Mixed")
          {
            returnValue = true;
          }
          else
          {
            returnValue = false;
          }
        }
          else if (!returnValue) {
          returnValue = this.role.includes(element.trim()) || element == "ALL";
        }
      });
    };
    if (returnValue && !mainMenuItem) {
      this.arrowHidden = true;
    }
    if (module == 'ALL' || (returnValue && mainMenuItem)) {
      this.links.push(url);
      localStorage.setItem('activeMenuLinks', this.links.toString())
      this.highlightOnLoad();
    }
    return returnValue;
  }

  public slidesList = new Array<never>(5);
  public showContent = true;
  public parentHeight = '12%';
  public timings = '0ms ease-in';
  public autoplay = false;
  public interval = 5000;
  public loop = true;
  public hideArrows = false;
  public hideIndicators = true;
  public color: ThemePalette = 'accent';
  public maxWidth = '55%';
  public maintainAspectRatio = false;
  public proportion = 25;
  public slideHeight = '80%';
  public slideWidth = '100%';
  public slides = this.slidesList.length;
  public overlayColor = '#00000000';
  public hideOverlay = false;
  public useKeyboard = true;
  public useMouseWheel = false;
  // public orientation: Orientation = 'ltr';
  public log: string[] = [];
  public darkMode = false;
  profileInitials: string = "";

  logout() {
    // this.router.navigate(['/'])
    localStorage.clear();
    setTimeout(() => {
      this.authService.logout();
      sessionStorage.clear();
    }, 1000);
    // localStorage.clear();
    // sessionStorage.clear();
    // this.router.navigate(['/'])
    // this.authService.logout();
  }

  getInitials() {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent);
    const fullName = this.userName.split(' ');
    if (fullName[0] != null && fullName[0] != undefined && fullName[1] != null && fullName[1] != undefined) {
      this.profileInitials = fullName[0]?.charAt(0) + fullName[1]?.charAt(0);
    }
  }

  highlightOnLoad() {
    let activeMenuLinks: any = localStorage.getItem('activeMenuLinks');
    if (activeMenuLinks != null) {
      console.log("highlightOnLoad");
      activeMenuLinks = activeMenuLinks.split(',');
      let url = window.location.href.split('/')
      this.selected.setValue(null);
      setTimeout(() => {
        this.currentIndex = activeMenuLinks.findIndex((x: any) => x == ("/" + url[3].trim()));
        this.selected.setValue(this.currentIndex);
        this.toggler(url[3]);
        // this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
      }, 1000);
    }
  }

  naviagte(url: any) {
    this.router.navigate([url])
  }

  callGetUserDetails() {
    let userId = localStorage.getItem("toyotaGUID");
    this.ngxUiLoaderService.start(this.constants.LoaderComponent);
    if(userId != null) {
      this.homeService.getUserDetails(userId).pipe(
        catchError((error: any) => {
          // this.router.navigate(['./unauthorized']);
          this.router.navigate(['/'])
          localStorage.clear();
          sessionStorage.clear();
          setTimeout(() => {
            this.authService.logout();
          }, 1000);
          return EMPTY;
        })).subscribe((response: any) => {
          if (response?.status == true) {
            localStorage.setItem("userDetails", JSON.stringify(response.user));
            sessionStorage.setItem("userDetails", JSON.stringify(response.user));
            sessionStorage.setItem("siteConfigRules", JSON.stringify(response.siteConfigRules));
            this.getUserDetails();
            setTimeout(() => {
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
            }, 5000);
          }
        });
    }
  }
}